import messages from "./messages";

export const languages = {
    defaultLanguage: 'ru',
    list: {
        en: 'En',
        ru: 'Ru'
    },
};
let currentLanguage = languages.defaultLanguage;

export default class IntManager {
    static setLanguage(lang, callback) {
        if (!lang) {
            currentLanguage = languages.defaultLanguage;
            callback(languages.defaultLanguage);
            return true;
        }

        if (!languages.list.hasOwnProperty(lang)) {
            return false;
        }

        currentLanguage = lang;

        callback(lang);
        return true;
    }

    static getLanguage() {
        return currentLanguage;
    }

    static getLanguageTitle(lang) {
        return languages.list.hasOwnProperty(lang) ? languages.list[lang] : '';
    }

    static getUrl(path) {
        const language = this.getLanguage();

        if (language === languages.defaultLanguage) {
            return path;
        }

        path = (path === '/' ? '' : path);
        return `/${language}${path}`;
    }

    static t(msg) {
        const language = this.getLanguage();

        if (messages.hasOwnProperty(msg)) {
            if (messages[msg].hasOwnProperty(language)) {
                return messages[msg][language]
            } else if (messages[msg].hasOwnProperty(languages.defaultLanguage)) {
                return messages[msg][languages.defaultLanguage]
            }
        }

        return '';
    }
}

export function t(msg) {
    return IntManager.t(msg)
}



// WEBPACK FOOTER //
// ./src/js/IntManager.js